<template>
  <component
    :is="tag"
    class="t-link border-none transition ease-in-out duration-150 focus-visible:ring-primary-400 focus-visible:ring-opacity-50 focus-visible:ring-primary-400 focus-visible:ring-3 focus-visible:outline-0 focus-visible:outline-none appearance-none cursor-pointer"
    :class="[VariantClasses[variant], underlineClasses, textClasses, classes]"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'
import type { TLinkTag, TLinkVariant } from './constants/types'
import { VariantClasses } from './constants/constants'

defineProps({
  tag: {
    type: String as PropType<TLinkTag>,
    default: 'button',
  },
  variant: {
    type: String as PropType<TLinkVariant>,
    default: 'primary',
  },
  underlineClasses: {
    type: String,
    default: 'no-underline focus:no-underline hover:no-underline',
  },
  textClasses: {
    type: String,
    default: 'font-bold font-sans leading-normal text-sm',
  },
  classes: {
    type: String,
  },
})
</script>
